import { render, staticRenderFns } from "./PAddressV1.vue?vue&type=template&id=17979832&scoped=true&"
import script from "./PAddressV1.vue?vue&type=script&lang=js&"
export * from "./PAddressV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17979832",
  null
  
)

export default component.exports